/*******************************************************************************
  SecurityConfig.js

  Author: Advait

*******************************************************************************/
import React, {Component} from 'react'
import SelectSite from '../components/SelectSite'
import '../index.css'

class SecurityConfig extends Component{

  //***************************************************************************
  // render the UI
  //***************************************************************************
  render(){
    return (
      <div className="fullPageDiv">
        <h3>Security Patrol Mode Configuration</h3>
        <SelectSite pageType ="roundConfig" scheduleType ="security_patrol"/>
      </div>
    )
  }
}
export default SecurityConfig
